import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

export interface AttachedClip {
  name: string;
  url: string;
  sopInstanceUID: string;
}

interface UpdateReportClipsPayload {
  reportId: string;
  attachedClips: AttachedClip[];
  sharedClipsName?: string;
}

export const updateReportClips = createAsyncThunk(
  'reports/updateReportClips',
  async (payload: UpdateReportClipsPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(REPORTS.UPDATE_REPORT_CLIPS(payload.reportId), {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ attachedClips: payload.attachedClips, sharedClipsName: payload.sharedClipsName }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Failed to update attached clips');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error as Error);
    }
  }
);
